import CryptoUtils from "./CryptoUtils";
import Routes from "../constants/Routes";
import Game from "../models/Game";

export default class GenUtils {

    public static moveToVerificationPage(game: Game) {
        let result = "";
        let previousServerSeed = game.previousServerSeed;
        let previousClientSeed = game.clientSeed;
        let previousNonce = game.previousNonce;
        if (previousServerSeed) {
            result = "?server_seed=" + previousServerSeed + "&server_seed_hash=" + CryptoUtils.SHA512Digest(previousServerSeed) + "&client_seed=" + previousClientSeed + "&nonce=" + previousNonce + "&gametype=" + game.gameType;
        }
        window.location.href = Routes.VERIFY_RESULTS + "/" + result;
    }

    public static computeEmptyRows(rowsPerPage: number, items: any[], page: number) {
        return rowsPerPage - Math.min(rowsPerPage, items.length - page * rowsPerPage)
    }
}